import { render, staticRenderFns } from "./editWorkList.vue?vue&type=template&id=1b74a208&scoped=true"
import script from "./editWorkList.vue?vue&type=script&lang=js"
export * from "./editWorkList.vue?vue&type=script&lang=js"
import style0 from "./editWorkList.vue?vue&type=style&index=0&id=1b74a208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b74a208",
  null
  
)

export default component.exports